
<nav id="site-specific-nav" class="ng-star-inserted">
    <ul *ngIf="!dataLoaded" class="ng-star-inserted">
        <li class="ng-star-inserted"><a [routerLink]="'/home'">&nbsp;</a></li>
    </ul>
    <ul *ngIf="dataLoaded" class="ng-star-inserted">
        <li class="ng-star-inserted"><a [routerLink]="'/home'" >Home</a></li>
        <li class="ng-star-inserted"><a [routerLink]="'/clarification-query'">Request for Clarification</a>
            <ul class="ng-star-inserted">
                <li class="ng-star-inserted"><a [routerLink]="'/clarification-query/all_query_request'">All Query Request</a></li>
                <li *ngIf="canViewMyQueryReq" class="ng-star-inserted"><a [routerLink]="'/clarification-query/my-query'">My Query Request</a></li>
                <li *ngIf="canViewPendingQueryReq" class="ng-star-inserted"><a [routerLink]="'/clarification-query/pending_query'">Pending Query</a></li>
                <li class="ng-star-inserted"><a [routerLink]="'/clarification-query/responded_query'">Responded Query</a></li>
            </ul>
        </li>
        <li *ngIf="currentUser.IsRFCAdmin" class="ng-star-inserted"><a href="#">Adminstration</a>
            <ul class="ng-star-inserted">
                <li class="ng-star-inserted"><a [routerLink]="'/admin/user_details'">User Details</a></li>
                <li class="ng-star-inserted"><a [routerLink]="'/admin/departments'">Departments</a></li>
                <li class="ng-star-inserted"><a [routerLink]="'/admin/sub_departments'">Sub Departments</a></li>
                <li class="ng-star-inserted"><a [routerLink]="'/admin/company'">Company</a></li>
                <li class="ng-star-inserted"><a [routerLink]="'/admin/dep_jv'">Dep Rep/JV Advisor Mapping</a></li>
                <li class="ng-star-inserted"><a [routerLink]="'/admin/holiday'">Holiday</a></li>
            </ul>
        <li *ngIf="!currentUser.Is_Partner" class="ng-star-inserted"><a [routerLink]="'/report'">Report</a></li>
        <li class="ng-star-inserted"><a target="_blank" rel="noopener" href="https://l.sasbu.chevron.net/web/">SASBU Home Page</a></li>
        <li class="ng-star-inserted"><a download="User Guide.docx" href="/assets/files/User Guide.docx">Help</a></li>
    </ul>
</nav>
